module.exports = __webpack_public_path__ + "static/media/categories.3bcef09b.png";